import { useTranslation } from 'react-i18next';
import { ExoVariants } from '../exo/ExoVariants';
import { NewDefaultEmailIntegration } from './NewDefaultEmailIntegration';
import EmailIcon from '@mui/icons-material/Email';
import GoogleIcon from '@mui/icons-material/Google';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import GroupsIcon from '@mui/icons-material/Groups';
import { NewGoogleEmailIntegration } from './NewGoogleEmailIntegration';
import { NewExchangeEmailIntegration } from './NewExchangeEmailIntegration';
import { NewSharedInboxIntegration } from './NewSharedInboxIntegration';
import { useEmailClient } from '../email-system/useEmailClient';

export const NewEmailIntegration = ({
  onChange,
  onDelete,
  userId,
  startData,
  onClose,
  debug,
}) => {
  const { t } = useTranslation();
  const { emailCredentials } = useEmailClient();

  const hasMicrosoftCredentials = (emailCredentials?.data || []).some(
    (c) => c.integrationToken?.type === 'exchange',
  );

  const variants = [
    {
      label: t('IMAP/SMTP'),
      Icon: EmailIcon,
      content: (
        <NewDefaultEmailIntegration
          onChange={onChange}
          onDelete={onDelete}
          userId={userId}
          startData={startData}
          onClose={onClose}
          debug={debug}
        />
      ),
    },
    /*{
      label: t('GMail'),
      Icon: GoogleIcon,
      content: <NewGoogleEmailIntegration onClose={onClose} />,
    },*/
    {
      label: t('Microsoft Exchange'),
      Icon: MicrosoftIcon,
      content: <NewExchangeEmailIntegration onClose={onClose} />,
    },
    {
      label: t('Shared Mailbox'),
      Icon: GroupsIcon,
      disabled: !hasMicrosoftCredentials,
      disabledMessage: 'Requires a connected Microsoft Exchange account',
      content: (
        <NewSharedInboxIntegration
          onChange={onChange}
          onClose={onClose}
          debug={debug}
        />
      ),
    },
  ];

  //Default in case both gmail and exchange should be hidden
  /*return (
    <NewDefaultEmailIntegration
      onChange={onChange}
      onDelete={onDelete}
      userId={userId}
      startData={startData}
      onClose={onClose}
      debug={debug}
    />
  );*/

  return startData ? (
    startData.integrationToken?.type === 'gmail' ? (
      <NewGoogleEmailIntegration onClose={onClose} />
    ) : startData.integrationToken?.type === 'exchange' ? (
      <NewExchangeEmailIntegration
        onChange={onChange}
        onDelete={onDelete}
        userId={userId}
        startData={startData}
        onClose={onClose}
        debug={debug}
      />
    ) : (
      <NewDefaultEmailIntegration
        onChange={onChange}
        onDelete={onDelete}
        userId={userId}
        startData={startData}
        onClose={onClose}
        debug={debug}
      />
    )
  ) : (
    <ExoVariants variants={variants} />
  );
};
